<template>
  <div class="main">
    <van-tabs v-model="active" sticky color="#FEB013" title-active-color="#FEB013">
      <van-tab v-for="(item, key) in tabList" :key="key" :title="item.title">
        <van-form @submit="onSubmit" label-width="80" style="padding: 8px 24px">
          <div class="title">①身份信息认证
            <div class="title_d">为保障你和乘客的出行顺利，请保证信息准确</div>
          </div>
          <van-field v-model="formData.Name" label="姓名" readonly/>
          <van-field v-model="formData.Phone" label="电话" placeholder="请填写电话号码" clearable type="tel" :rules="[{ required: true }]"/>
          <div v-if="active === 1">
            <div class="title">②车辆信息认证</div>
            <van-field v-model="formData.CarBrand" label="品牌" placeholder="请输入车辆品牌 例如：丰田" clearable :rules="[{ required: true }]"/>
            <van-field
              v-model="formData.CarName"
              label="车型"
              placeholder="请输入车辆系列 例如：卡罗拉"
              clearable
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="formData.CarNum"
              label="车牌号码"
              placeholder="请填写车牌号码"
              clearable
              :rules="[{ pattern, message: '请输入正确车牌号' }]"
            />
            <div style="display:flex;justify-content: space-between;">
              <div style="background-color:#F5F5F5;padding: 12px 0 0 12px;border-radius: 4px;width: 45%;">
                <div>车辆颜色</div>
                <van-field v-model="formData.CarColor" placeholder="请填写车辆颜色" clearable :rules="[{ required: true }]" style="padding:0;width: 90%;"/>
              </div>
              <div span="12" style="background-color:#F5F5F5;padding: 12px 0 0 12px;border-radius: 4px;width: 45%;">
                <div>座位</div>
                <van-field name="CarSeat" style="padding:0;width: 90%;">
                  <template #input>
                    <van-stepper v-model="formData.CarSeat" theme="round" button-size="22"/>
                  </template>
                </van-field>
              </div>
            </div>
            <div class="title">③路线设置</div>
            <van-cell is-link @click="show = true">
              <template #title>
                <van-image width="20" height="20" :src="require('../../assets/img1.svg')" style="top:5px;"/>
                {{routeTitle}}
              </template>
            </van-cell>
            <!-- <van-field v-model="routeData.Origin" label="出发地" placeholder="请填写出发地" clearable :rules="[{ required: true }]"/> -->
            <van-field v-model="routeData.Destination" label="目的地" placeholder="请填写目的地" clearable :rules="[{ required: true }]"/>
            <van-field v-model="routeData.Way" label="途径地" placeholder="多个途径地用空格键分开" clearable :rules="[{ required: true }]"/>
            <van-field
              v-model="routeData.DepartTime"
              label="时间"
              placeholder="请选择时间"
              readonly
              clearable
              right-icon="arrow"
              @click="showPicker = true"
              :rules="[{ required: true }]"/>
            <van-field v-model="routeData.Remark" label="备注" placeholder="(选填)填写备注" clearable />
          </div>
          <div style="margin: 20px 20px 40px 20px;">
            <van-button round block color="#FEB013" type="info" native-type="submit">提交认证</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>

    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="time"
        :min-hour="minDate"
        @confirm="onConfirmTime"
        @cancel="showPicker = false"
      />
    </van-popup>

    <van-popup v-model="show" round position="bottom">
      <van-radio-group v-model="Radio" style="margin-top: 20px;">
        <div
          v-for="(item, key) in RList"
          :key="key" class="radioBox"
          @click="checkRadio(item)"
          :style="item.name === Radio ?'background-color: rgba(254, 176, 19, 0.1);':'background-color: #F5F5F5;'">
          <div style="display: flex;align-items: center;">
            <van-image width="20" height="20" :src="require('../../assets/img1.svg')"/>
            <div>路线{{item.name}}:{{item.detail}}</div>            
          </div>
          <van-radio :name="item.name" checked-color="#FEB013"/>
        </div>
      </van-radio-group>
      <div style="margin: 20px 20px 40px 20px;">
        <van-button round block color="#FEB013" @click="show = false">保存变更</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      tabList: [
        {title: '我是乘客', value: 'passenger'},
        {title: '我是司机', value: 'driver'}
      ],
      formData: {},
      routeData: {},
      show: false,
      Radio: '',
      routeTitle: '请设置路线',
      showPicker: false,
      minDate: new Date().getHours(),
      pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/,
      JSUserList: [],
      RList: []
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"area": "健树","errcode":0,"errmsg":"ok","userid":"201755101","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // const test = {"errno":0,"data":{"area": "健树","errcode":0,"errmsg":"ok","userid":"20211238","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data

    this.active = this.$route.query.role === 'passenger' ? 0 : 1
    // 是否已注册
    if (this.$route.query.register === 'false') {
        this.formData = {
          Avatar: this.WXInfo.avatar,
          // OpenId: this.WXInfo.openid,
          UserId: this.WXInfo.userid,
          Name: this.WXInfo.name,
          Sex: this.WXInfo.gender === '1' ? '男' : '女',
          Phone: this.WXInfo.mobile,
          CarSeat: '4'
        }
    } else {
      this.getUserInfo()
    }
    // 路线列表识别
    this.RList = this.WXInfo.area === '健树' ? this.$JSRoute : this.$Route
  },
  methods: {
    checkRadio (value) {
      this.Radio = value.name
      this.routeData.Route = value.name
      this.routeTitle = '路线'+value.name+':'+value.detail
      this.show = false
    },
    onConfirmTime (val) {
      this.routeData.DepartTime = val
      this.showPicker = false
    },
    async getUserInfo() {
      const result = await this.getUserInfoData()
      if (result.data.length > 0) {
        this.formData = result.data[0]
        if (result.data[0].routerInfo.length > 0) {
          const routerInfo = result.data[0].routerInfo[0]
          this.routeData = routerInfo
          this.routeTitle = '路线'+routerInfo.Route+':'+this.RList.find(value=>value.name === routerInfo.Route).detail
          this.Radio = routerInfo.Route          
        } else {
          this.formData.CarSeat = '4'
        }
      } else {
        this.$toast(result.message)
      }
    },
    async onSubmit() {
      if (this.active && this.routeTitle === '请设置路线') {
        this.$toast('路线为空，不允许提交。')
      } else {
        if (!this.active) {
          this.formData = {
            Avatar: this.WXInfo.avatar,
            // OpenId: this.WXInfo.openid,
            UserId: this.WXInfo.userid,
            Name: this.WXInfo.name,
            Sex: this.WXInfo.gender === '1' ? '男' : '女',
            Phone: this.formData.Phone
          }
        } else {
          // 新增默认路线信息
          this.routeData.OpenId = this.WXInfo.openid
          this.routeData.UserId = this.WXInfo.userid
          this.routeData.Origin = '公司'
          const value = await this.postUserRouteData(this.routeData)
          if (!value.success) {
            this.$toast(value.message)
            return
          }
        }
        this.formData.Role = this.active ? 'driver':'passenger'
        this.formData.Area = this.WXInfo.area
        localStorage.setItem('Role', this.formData.Role)
        localStorage.setItem('Phone', this.formData.Phone)
        const result = await this.postUserCarData(this.formData)
        if (result.success) {
          this.$router.push('/index?role=' + this.formData.Role)
        } else {
          this.$toast(result.message)
        }        
      }
    },
    // API
    // 查询用户数据
    getUserInfoData() {
      return this.$request({
        url: '/api/UserCar/getUserCarInfo',
        method: 'GET',
        params: {
          UserId: this.WXInfo.userid
        }
      })
    },
    // 新增/更新用户基础数据
    postUserCarData(data) {
      return this.$request({
        url: this.$api.postUserCar,
        method: 'POST',
        params: {
          UserId: this.WXInfo.userid
        },
        data
      })
    },
    // 新增/更新司机默认路线信息
    postUserRouteData(data) {
      return this.$request({
        url: this.$api.postUserRoute,
        method: 'POST',
        params: {
          UserId: this.WXInfo.userid
        },
        data
      })
    }
  }
};
</script>

<style lang="less" scoped>
  .main {
    background: #FFFFFF;
  }
  /deep/.van-cell {
    background-color: #F5F5F5;
    margin: 8px 0;
    border-radius: 4px;
    padding: 10px 12px;
    font-size: 16px;
  }
  /deep/.van-stepper--round .van-stepper__plus {
    background-color: #FEB013;
  }
  /deep/.van-stepper--round .van-stepper__minus {
    color: #FFFFFF;
    background-color: #999999;
    border:initial;
  }
  /deep/.van-radio__icon .van-icon {
    border: initial;
  }

  .title {
    font-weight: bold;
    font-size: 18px;
    padding: 10px 0;
  }
  .title_d {
    font-size:12px;
    color: #999999;
    font-weight: initial;
    padding-top:8px;
  }
  .radioBox {
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    padding: 16px;
    margin: 12px;
    font-size: 15px;
    font-weight: bold;
  }
</style>
